import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLang } from "../i18n";
import api, { formatApiError } from "../api";

const ResetPassword = () => {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="pt-16 min-h-screen flex items-center justify-center px-5" data-testid="reset-page">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-card p-8 sm:p-10">
        <h1 className="font-display font-bold text-2xl mb-8">{t("reset_title")}</h1>
        {done ? (
          <div>
            <p className="text-gold text-sm mb-6" data-testid="reset-success">{t("reset_done")}</p>
            <Link to="/accedi" data-testid="reset-login-link" className="inline-flex rounded-full bg-ember px-6 py-3 text-sm font-semibold uppercase tracking-wider text-black">
              {t("nav_login")}
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="reset-password-input" required type="password" minLength={6}
              className="w-full rounded-lg border border-white/15 bg-black/40 px-4 py-3 text-sm focus:border-ember focus:outline-none"
              placeholder={t("auth_password")} value={password} onChange={(e) => setPassword(e.target.value)} />
            {error && <p data-testid="reset-error" className="text-sm text-red-400">{error}</p>}
            <button data-testid="reset-submit-button" disabled={busy}
              className="w-full rounded-full bg-ember py-3.5 text-sm font-semibold uppercase tracking-wider text-black hover:bg-gold transition-colors disabled:opacity-50">
              {t("reset_btn")}
            </button>
          </form>
        )}
      </div>
    </main>
  );
};

export default ResetPassword;
